import { leerNumero } from '../formato'

/** El tope del motor y del servidor: un 50 escrito en vez de 5 no llega al cliente. */
const MAXIMA = 30

/**
 * Lo escrito -> lo que se manda al servidor. `null` = sin comision (vacio o 0): asi la
 * entrada sin comision es la de siempre y no lleva la clave. Un texto es un error para mostrar.
 */
export function leerComision(texto: string): number | null | string {
  const n = leerNumero(texto)
  if (n === null || n === 0) return null
  if (Number.isNaN(n) || n < 0 || n > MAXIMA) return `La comisión va en %, entre 0 y ${MAXIMA} (por ejemplo 5).`
  return n / 100
}

interface Props {
  valor: string
  alCambiar: (valor: string) => void
}

/** Comision del vendedor: sube cada rubro en ese %, asi el cliente no la ve como concepto aparte. */
export function CampoComision({ valor, alCambiar }: Props) {
  return (
    <label>
      Comisión del vendedor (%)
      <input value={valor} onChange={(e) => alCambiar(e.target.value)} inputMode="decimal" placeholder="Vacío = sin comisión" />
      <small className="ayuda">Sube el total en ese % repartido en cada rubro. No cuenta como utilidad y no aparece en el PDF.</small>
    </label>
  )
}
